<script setup lang="ts">
import { useJobBoardStore } from '@/core/collections/job-boards/job-board.store';

const viewport = inject<'desktop' | 'tablet' | 'mobile'>('viewport');

const props = defineProps({
   data: {
      type: Object,
      default: () => ({}),
   },
});

const jobBoardStore = useJobBoardStore();
const activeLang = computed(() => jobBoardStore.activeLanguageName);
const headerText = computed(() => props.data.title[activeLang.value] || '');
</script>

<template>
   <header :class="['header-content', { 'header-content--mobile': viewport === 'mobile' }]">
      <div v-if="data.background_color" class="header-content__bg" :style="{ backgroundColor: data.background_color }"></div>
      <img v-if="data.background_image" :src="data.background_image" class="header-content__image" />
      <div class="header-content__text" :style="{ color: data.text_color }" v-html="headerText"></div>
   </header>
</template>

<style lang="scss" scoped>
.header-content {
   height: 450px;
   width: 100%;
   position: relative;

   &__text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 36px;
      line-height: 36px;
      color: #000000;
   }

   &__image {
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
   }

   &__bg {
      position: absolute;
      width: 100%;
      height: 100%;
   }

   @media (max-width: 768px) {
      height: 350px;
   }

   @media (max-width: 400px) {
      height: 250px;
   }

   &.header-content--mobile {
      height: 250px;
   }
}
</style>
